export default defineNuxtPlugin((nuxtApp) => {
    const isClient = import.meta.client;
    const indicator = isClient ? useLoadingIndicator() : null;
    let mounted = false;
    let preMountActivity = false;
    const pending = new Set<string>();

    if(isClient) {
        nuxtApp.hook('app:mounted', () => {
            mounted = true;
            if(pending.size > 0) {
                indicator.start()
            } else if(preMountActivity) {
                indicator.start();
                setTimeout(() => indicator.finish(), 150);
            }
        })
    }

    function start(id = crypto.randomUUID()) {
        if(!isClient) {
            pending.add(id)
            return id;
        }

        if(!mounted) {
            preMountActivity = true;
        }
        pending.add(id)
        if(mounted && pending.size === 1) {
            indicator.start();
        }
        return id;
    }

    function finish(id?: string) {
        if(id) {
            pending.delete(id);
        }else {
            pending.clear();
        }
        if(!isClient) return;
        if(mounted && pending.size === 0) {
            indicator.finish();
        }
    }

    async function withLoader<T>(fn: () => Promise<T>) {
        const id = start();
        try {
            return await fn();
        } finally {
            finish(id);
        }
    }

    if(isClient) {
        nuxtApp.hook('page:start', () => start('__route__'));
        nuxtApp.hook('page:finish', () => finish('__route__'));
    }

    return { provide: { loader: { start, finish, withLoader } } }
})
